/** Keys whose values are URL slugs and must not be hyphen-normalized for the API. */
const SLUG_FILTER_KEYS = new Set([
  'profile',
  'endUser',
  'keyword',
  'category',
  'subcategory',
  'subSubcategory',
  'subSubSubcategory',
  'subSubSubSubcategory',
  'subSubSubSubSubcategory',
  'subSubSubSubSubSubcategory',
  'subSubSubSubSubSubSubcategory',
  'subSubSubSubSubSubSubSubcategory',
]);

function isEmptyFilterValue(value: unknown): boolean {
  return value === null || value === undefined || value === '' || value === 'null' || value === 'undefined';
}

/** Build the filter object sent to backend search/list endpoints. */
export function buildListingFilterParams(listingFilter: Record<string, unknown>): Record<string, unknown> {
  const o: Record<string, unknown> = {};
  for (const key of Object.keys(listingFilter)) {
    const value = listingFilter[key];
    if (isEmptyFilterValue(value)) {
      continue;
    }

    if (key === 'attributes' && typeof value === 'object' && !Array.isArray(value)) {
      const cleaned: Record<string, string> = {};
      for (const [attrKey, attrVal] of Object.entries(value as Record<string, unknown>)) {
        if (!isEmptyFilterValue(attrVal)) {
          cleaned[attrKey] = String(attrVal);
        }
      }
      if (Object.keys(cleaned).length > 0) {
        o.attributes = cleaned;
      }
      continue;
    }

    const str = `${value}`;
    if (str !== 'null' && str !== 'undefined' && str !== '') {
      o[key] = SLUG_FILTER_KEYS.has(key) ? str : str.replace('-', ' ');
    }
  }

  // Canonical taxonomy path for /api/listings/search (alongside discrete category fields).
  const path = buildBrowseCategoryPath(o);
  if (path) {
    o.path = path;
  }
  return o;
}

/** Slash path from category + subcategory… fields (skips all* placeholders). */
export function buildBrowseCategoryPath(filter: Record<string, unknown>): string | null {
  const keys = [
    'category',
    'subcategory',
    'subSubcategory',
    'subSubSubcategory',
    'subSubSubSubcategory',
    'subSubSubSubSubcategory',
    'subSubSubSubSubSubcategory',
    'subSubSubSubSubSubSubcategory',
    'subSubSubSubSubSubSubSubcategory',
  ];
  const parts: string[] = [];
  for (const key of keys) {
    const raw = filter[key];
    if (isEmptyFilterValue(raw)) {
      continue;
    }
    let segment = `${raw}`.trim().toLowerCase();
    if (!segment || segment === 'all' || segment.startsWith('all ')) {
      break;
    }
    if (segment.startsWith('all-')) {
      segment = segment.slice(4);
    }
    if (!segment) {
      break;
    }
    parts.push(segment.replace(/\s+/g, '-'));
  }
  return parts.length ? parts.join('/') : null;
}
